import { LitElement, html, css } from 'lit';

class CopyModalButton extends LitElement {
  static properties = {
    isOpen: { type: Boolean, reflect: true },
    facilityName: { type: String, reflect: true },
    url: { type: String, reflect: true },
  }
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this.isOpen = false;
  }
  static styles = css`
    .copy-button {
      display: flex;
      column-gap: 4px;
      align-items: center;
      justify-content: center;
      padding: 10px 8px;
      height: 44px;
      border-radius: 8px;
      background-color: #fff;
      box-shadow: 0px 2px  rgba(38, 50, 36, 0.16);
      color: #273238;
      text-decoration: none;
      font-size: 12px;
      box-sizing: border-box;
      &:hover {
        cursor: pointer;
      }
    }
    .copy-modal {
      animation: fadeIn 0.3s ease 0s 1 normal;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0.5);
      z-index: 2000;
      display: flex;
      justify-content: center;
      align-items: center;
      .modal-content {
        font-size: 14px;
        position: relative;
        box-sizing: border-box;
        border-radius: 8px;
        background-color: #FFF;
        padding: 24px;
        width: 100%;
        max-width: 360px;
        .title {
          display: flex;
          align-items: center;
          gap: 8px;
          padding-bottom: 24px;
          margin-bottom: 24px;
          border-bottom: 1px solid #A8ABA6;
          .label {
            font-weight: bold;
            font-size: 16px;
            line-height: 20px;
            text-align: start;
          }
        }
        .description {
          text-align: start;
          margin-bottom: 24px;
        }
        .url {
          margin-bottom: 40px;
          text-align: start;
        }
        .close-button {
          padding: 16px 8px;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 12px;
          color: #263238;
          border-radius: 8px;
          box-shadow: 0px 2px 0px 0px rgba(38, 50, 56, 0.16);
          display: flex;
          justify-content: center;
          align-items: center;
          background: #eee;
          cursor: pointer;
        }
      }
    }
    
    `
  updated(changedProperties) {
  }
  closeModal() {
    this.isOpen = false;
  }
  openModal() {
    this.isOpen = true;
    window.navigator.clipboard.writeText(this.url);
  }
  render() {
    return html`
      <div class="copy-button" @click="${this.openModal}">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <circle cx="11.9998" cy="12.0001" r="9.81818" fill="#263238"/>
          <path d="M13.8292 14.6566L11.9664 16.5194C11.3149 17.1709 10.5309 17.4967 9.61466 17.4968C8.69839 17.4968 7.91465 17.1712 7.26342 16.52C6.6122 15.8688 6.2861 15.0845 6.28512 14.1672C6.28414 13.2499 6.60943 12.4655 7.26099 11.814L9.12379 9.95116L9.98754 10.8149L8.1259 12.6765C7.71081 13.0916 7.50299 13.5884 7.50241 14.1667C7.50184 14.7451 7.70869 15.2414 8.12295 15.6557C8.53722 16.0699 9.03413 16.2774 9.61369 16.278C10.1932 16.2786 10.6906 16.0714 11.1056 15.6563L12.9673 13.7947L13.8292 14.6566ZM10.4534 14.1236L9.65856 13.3288L13.3271 9.66029L14.1219 10.4551L10.4534 14.1236ZM14.6549 13.8309L13.7929 12.969L15.6546 11.1074C16.0696 10.6923 16.2775 10.1956 16.278 9.61719C16.2786 9.03883 16.0718 8.54251 15.6575 8.12825C15.2432 7.71398 14.7463 7.50654 14.1668 7.50591C13.5872 7.50531 13.0899 7.71254 12.6748 8.12763L10.8132 9.98927L9.94943 9.12552L11.8122 7.26272C12.4634 6.61155 13.248 6.28598 14.1659 6.28602C15.0839 6.28606 15.8684 6.61169 16.5197 7.26291C17.1709 7.91414 17.4962 8.69836 17.4955 9.61557C17.4948 10.5328 17.1688 11.317 16.5177 11.9681L14.6549 13.8309Z" fill="white"/>
        </svg>
        <div class="copy-button-label">リンクをコピー</div>
      </div>
      ${this.isOpen ? html`
        <div class="copy-modal">
          <div class="modal-content">
            <div class="title">
              <div class="label">
                リンクをコピーしました！
              </div>
            </div>
            <div class="description">
              <b>「${this.facilityName}」</b>のURLをクリップボードにコピーしました。
            </div>
            <div class="url">
              <a href="${this.url}">${this.url}</a>
            </div>
            <div class="close-button" @click=${this.closeModal}>
              閉じる
            </div>
          </hr>
        </div>
      ` : ''}
    `;
  }
}

if (!customElements.get('copy-modal-button'))
  customElements.define('copy-modal-button', CopyModalButton);